export default function () {
  if (document.querySelector('.js-filterSearch')) {
    const parents = document.querySelectorAll('.js-filterSearch');

    parents.forEach(function (parentElement) {
      const sites = parentElement.querySelector('.js-filterSearch_sites');
      const lists = parentElement.querySelectorAll('.js-filterSearch_list');

      lists.forEach(function (listElement) {
        const items = listElement.querySelectorAll('.js-filterSearch_item');

        function liveSearch() {
          let search_query = parentElement.querySelector('.js-filterSearch_input').value;

          // show/hide items if they contain input value
          for (let i = 0; i < items.length; i++) {
            if (items[i].textContent.toLowerCase()
              .includes(search_query.toLowerCase())) {
              items[i].classList.remove('hidden');
              items[i].classList.add('showing');
            } else {
              items[i].classList.add('hidden');
              items[i].classList.remove('showing');
            }
          }

          let shown_items = listElement.querySelectorAll('.showing');

          // hide list if all its items are hidden
          if (shown_items.length < 1) {
            listElement.classList.add('hidden');
          } else {
            listElement.classList.remove('hidden');
          }

          // change items layout when less than 30 items per list are shown
          if (shown_items.length < 30) {
            sites.classList.add('tabBody_sites-grid');
          } else {
            sites.classList.remove('tabBody_sites-grid');
          }
        }

        let typingTimer;
        let typeInterval = 250;
        let searchInput = parentElement.querySelector('.js-filterSearch_input');

        searchInput.addEventListener('keyup', () => {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(liveSearch, typeInterval);
        });
      });

    });
  }
}
